import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Container } from 'react-bootstrap';

export default function Layout({ children }) {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      
      <Header /> 

      {/* Main content uses a standard container for max-width and centering */}
      <Container className="my-5"> 
        {children} 
      </Container>
      
      <Footer />
      
    </div>
  );
}